import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import data from "../api/databaseApi";

const StudentDetails = () =>{
    const { studentid } = useParams();
    const navigate = useNavigate();
    const [studentData, setStudentData] = useState({});
    const [classData, setClassData] = useState({});
    const [semesterData, setSemesterData] = useState({});
    useEffect(() =>{
        const update = async () =>{
            const studentData = await data.getStudent(studentid);
            const classData = await data.getClass(studentData.classId);
            const semesterData = await data.getSemester(classData.semesterId);
            setStudentData(studentData);
            setClassData(classData);
            setSemesterData(semesterData);
        }
        update();
    },[studentid]);
    const upDateAttendance = async (id) =>{
        console.log(JSON.stringify(studentData));
        let record = studentData.attendance;
        if(record === undefined){
            record = [];
        }
        if(!record.includes(new Date().toDateString())){
            record.push(new Date().toDateString());
        }
        let toSave = {}
        toSave.attendance = record
        setStudentData(await data.updateStudent(id,toSave))
    }
    return (
        <div className="container">
            <div className="container">
                <div className="row">
                    <button className="col btn btn-light border border-1" onClick={()=>{navigate(-1)}}>Back</button>
                    <button className="col btn btn-light border border-1" onClick={() =>{upDateAttendance(studentid)}}>Mark As Present</button>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col">
                        <div className="container pb-1">
                            <div className="row">
                                <div className="col"><span className="fw-bold">Name:</span> {studentData.name}</div>
                                <div className="col"><span className="fw-bold">Email:</span> {studentData.email}</div>
                            </div>
                            <div className="row">
                                <div className="col"><span className="fw-bold">Class:</span> {classData.name}</div>
                            </div>
                            <div className="row">
                                <div className="col"><span className="fw-bold">Semester:</span> {semesterData.name}</div>
                            </div>
                        </div>
                        <img style={{width:"100%"}} src={`https://api.qrserver.com/v1/create-qr-code/?size=600x600&data=${btoa(studentData.name+"-"+studentData.email)}`} alt="" />
                    </div>
                    <div className="col">
                        {studentData.attendance !== undefined &&
                            (studentData.attendance.map((date, index) =>{
                                return (
                                    <li key={index}>{date}</li>
                                )
                            })
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StudentDetails;